var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruckDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "truck-delivery"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5C1 4.44772 1.44772 4 2 4H13C13.5523 4 14 4.44772 14 5H18C18.3513 5 18.6768 5.1843 18.8575 5.4855L21.8575 10.4855C21.9507 10.6409 22 10.8188 22 11V17C22 17.5523 21.5523 18 21 18H19.8293C19.4175 19.1652 18.3062 20 17 20C15.6938 20 14.5825 19.1652 14.1707 18H9.82929C9.41746 19.1652 8.30622 20 7 20C5.69378 20 4.58254 19.1652 4.17071 18H3C2.44772 18 2 17.5523 2 17V13C2 12.4477 2.44772 12 3 12C3.55228 12 4 12.4477 4 13V16H4.17071C4.58254 14.8348 5.69378 14 7 14C8.30622 14 9.41746 14.8348 9.82929 16H12V6H2C1.44772 6 1 5.55228 1 5ZM14 7V10H19.2338L17.4338 7H14ZM20 12H14V16H14.1707C14.5825 14.8348 15.6938 14 17 14C18.3062 14 19.4175 14.8348 19.8293 16H20V12ZM2 9C2 8.44772 2.44772 8 3 8H7C7.55228 8 8 8.44772 8 9C8 9.55228 7.55228 10 7 10H3C2.44772 10 2 9.55228 2 9ZM7 16C6.44772 16 6 16.4477 6 17C6 17.5523 6.44772 18 7 18C7.55228 18 8 17.5523 8 17C8 16.4477 7.55228 16 7 16ZM17 16C16.4477 16 16 16.4477 16 17C16 17.5523 16.4477 18 17 18C17.5523 18 18 17.5523 18 17C18 16.4477 17.5523 16 17 16Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckDelivery);
export default __webpack_public_path__ + "static/media/truck-delivery.ec76775dc4708a79faf14e3fd90c471e.svg";
export { ForwardRef as ReactComponent };